.chevron {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
}

.icon {
  width: 1.5rem;
  height: 1.5rem;

  position: absolute;
  top: 0;
  left: 0;

  transition: opacity 0.2s ease;
  stroke-width: 1.5;
}

.iconPlus {
  opacity: 1;
}

.iconMinus {
  opacity: 0;
}

.chevron[data-rotate] {
  .iconPlus {
    opacity: 0;
  }

  .iconMinus {
    opacity: 1;
  }
}

.root {
  display: flex;
  flex-direction: column;

  gap: 0.5rem;
}

.item {
  padding: 0;
  border-bottom: 0;
}

.control {
  padding: 1rem 1.5rem !important;

  background-color: var(--mantine-color-primary-0) !important;
  border-radius: 0.75rem !important;

  &:hover,
  &:active {
    background-color: var(--mantine-color-primary-0) !important;
  }
}

.content {
  background-color: var(--mantine-color-otherWhite-0) !important;
  padding: 1.5rem !important;
}
